const firebaseConfig = {
    apiKey: "AIzaSyBapFsdrxC19sCLG1UBhlouN5BWjdoKFbk",
    authDomain: "bitcoinjito-e3078.firebaseapp.com",
    projectId: "bitcoinjito-e3078",
    storageBucket: "bitcoinjito-e3078.firebasestorage.app",
    messagingSenderId: "1075736328609",
    appId: "1:1075736328609:web:a754485d4d560859e5f3e0",
    measurementId: "G-KZ8H8YB5RV"
  };
  

export default firebaseConfig;
